/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlackListNumberCreate } from '../models/BlackListNumberCreate';
import type { ClientCreate } from '../models/ClientCreate';
import type { PatchedClientCreate } from '../models/PatchedClientCreate';
import type { PatchedProviderCreate } from '../models/PatchedProviderCreate';
import type { PatchedSIPLineCreate } from '../models/PatchedSIPLineCreate';
import type { PatchedVirtualNumberCreate } from '../models/PatchedVirtualNumberCreate';
import type { PatchedWorkerCreate } from '../models/PatchedWorkerCreate';
import type { PatchedWorkerSIPLineCreate } from '../models/PatchedWorkerSIPLineCreate';
import type { ProviderCreate } from '../models/ProviderCreate';
import type { ProviderTriggerCall } from '../models/ProviderTriggerCall';
import type { SIPLineCreate } from '../models/SIPLineCreate';
import type { VirtualNumberCreate } from '../models/VirtualNumberCreate';
import type { VirtualNumberUpdateStatus } from '../models/VirtualNumberUpdateStatus';
import type { WorkerCreate } from '../models/WorkerCreate';
import type { WorkerSIPLineCreate } from '../models/WorkerSIPLineCreate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TelephonyService {
    /**
     * @returns BlackListNumberCreate
     * @throws ApiError
     */
    public static telephonyBlacklistNumbersList(): CancelablePromise<Array<BlackListNumberCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/blacklist_numbers/',
        });
    }
    /**
     * @returns BlackListNumberCreate
     * @throws ApiError
     */
    public static telephonyBlacklistNumbersCreate({
        requestBody,
    }: {
        requestBody: BlackListNumberCreate,
    }): CancelablePromise<BlackListNumberCreate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/blacklist_numbers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyBlacklistNumbersDestroy({
        number,
    }: {
        number: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/blacklist_numbers/{number}/',
            path: {
                'number': number,
            },
        });
    }
    /**
     * @returns ClientCreate
     * @throws ApiError
     */
    public static telephonyClientsList(): CancelablePromise<Array<ClientCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/clients/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyClientsCreate({
        requestBody,
    }: {
        requestBody: ClientCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/clients/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ClientCreate
     * @throws ApiError
     */
    public static telephonyClientsRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<ClientCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/clients/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyClientsUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ClientCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/clients/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyClientsPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedClientCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/clients/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyClientsDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/clients/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ProviderCreate
     * @throws ApiError
     */
    public static telephonyProvidersList(): CancelablePromise<Array<ProviderCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersCreate({
        requestBody,
    }: {
        requestBody: ProviderCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/providers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ProviderCreate
     * @throws ApiError
     */
    public static telephonyProvidersRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<ProviderCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ProviderCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedProviderCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/providers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyProvidersDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/providers/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersPauseUpdate({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{id}/pause/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersPurgeUpdate({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{id}/purge/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersResumeUpdate({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{id}/resume/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns SIPLineCreate
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesList({
        providerPk,
    }: {
        providerPk: string,
    }): CancelablePromise<Array<SIPLineCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/',
            path: {
                'provider_pk': providerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesCreate({
        providerPk,
        requestBody,
    }: {
        providerPk: string,
        requestBody: SIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/',
            path: {
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SIPLineCreate
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesRetrieve({
        id,
        providerPk,
    }: {
        id: string,
        providerPk: string,
    }): CancelablePromise<SIPLineCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        id: string,
        providerPk: string,
        requestBody: SIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesPartialUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        id: string,
        providerPk: string,
        requestBody?: PatchedSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesDestroy({
        id,
        providerPk,
    }: {
        id: string,
        providerPk: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersRetrieve({
        providerPk,
        sipLinePk,
    }: {
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/',
            path: {
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersCreate({
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        providerPk: string,
        sipLinePk: string,
        requestBody: VirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/',
            path: {
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersRetrieve2({
        number,
        providerPk,
        sipLinePk,
    }: {
        number: string,
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/{number}/',
            path: {
                'number': number,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersUpdate({
        number,
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        number: string,
        providerPk: string,
        sipLinePk: string,
        requestBody: VirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/{number}/',
            path: {
                'number': number,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersPartialUpdate({
        number,
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        number: string,
        providerPk: string,
        sipLinePk: string,
        requestBody?: PatchedVirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/{number}/',
            path: {
                'number': number,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesVirtualNumbersDestroy({
        number,
        providerPk,
        sipLinePk,
    }: {
        number: string,
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/virtual_numbers/{number}/',
            path: {
                'number': number,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns WorkerSIPLineCreate
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersList({
        providerPk,
        sipLinePk,
    }: {
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<Array<WorkerSIPLineCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/',
            path: {
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersCreate({
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        providerPk: string,
        sipLinePk: string,
        requestBody: WorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/',
            path: {
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns WorkerSIPLineCreate
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersRetrieve({
        id,
        providerPk,
        sipLinePk,
    }: {
        id: string,
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<WorkerSIPLineCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersUpdate({
        id,
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        id: string,
        providerPk: string,
        sipLinePk: string,
        requestBody: WorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersPartialUpdate({
        id,
        providerPk,
        sipLinePk,
        requestBody,
    }: {
        id: string,
        providerPk: string,
        sipLinePk: string,
        requestBody?: PatchedWorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyProvidersSipLinesWorkersDestroy({
        id,
        providerPk,
        sipLinePk,
    }: {
        id: string,
        providerPk: string,
        sipLinePk: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/providers/{provider_pk}/sip_lines/{sip_line_pk}/workers/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
                'sip_line_pk': sipLinePk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyProvidersTriggerCallCreate({
        requestBody,
    }: {
        requestBody: ProviderTriggerCall,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/providers/trigger_call/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SIPLineCreate
     * @throws ApiError
     */
    public static telephonySipLinesList(): CancelablePromise<Array<SIPLineCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/sip_lines/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonySipLinesCreate({
        requestBody,
    }: {
        requestBody: SIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/sip_lines/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SIPLineCreate
     * @throws ApiError
     */
    public static telephonySipLinesRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<SIPLineCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/sip_lines/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonySipLinesUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: SIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/sip_lines/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonySipLinesPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/sip_lines/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonySipLinesDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/sip_lines/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns VirtualNumberCreate
     * @throws ApiError
     */
    public static telephonyVirtualNumbersList({
        clientIsnull,
        sipLineProvider,
    }: {
        clientIsnull?: string,
        sipLineProvider?: Array<string>,
    }): CancelablePromise<Array<VirtualNumberCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/virtual_numbers/',
            query: {
                'client__isnull': clientIsnull,
                'sip_line__provider': sipLineProvider,
            },
        });
    }
    /**
     * 1. Adds virtual number to FSM first;
     * 1.1 if Fails return with Error
     * 2. Adds virtual number to TPS
     * 2.1 if Fails
     * 2.1.1 Delete virtual number from FSM
     * 2.1.2 Return response
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyVirtualNumbersCreate({
        requestBody,
    }: {
        requestBody: VirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/virtual_numbers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns VirtualNumberCreate
     * @throws ApiError
     */
    public static telephonyVirtualNumbersRetrieve({
        number,
    }: {
        number: string,
    }): CancelablePromise<VirtualNumberCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/virtual_numbers/{number}/',
            path: {
                'number': number,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyVirtualNumbersUpdate({
        number,
        requestBody,
    }: {
        number: string,
        requestBody: VirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/virtual_numbers/{number}/',
            path: {
                'number': number,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyVirtualNumbersPartialUpdate({
        number,
        requestBody,
    }: {
        number: string,
        requestBody?: PatchedVirtualNumberCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/virtual_numbers/{number}/',
            path: {
                'number': number,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyVirtualNumbersDestroy({
        number,
    }: {
        number: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/virtual_numbers/{number}/',
            path: {
                'number': number,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyVirtualNumbersUpdateStatusCreate({
        number,
        requestBody,
    }: {
        number: string,
        requestBody: VirtualNumberUpdateStatus,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/virtual_numbers/{number}/update_status/',
            path: {
                'number': number,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns WorkerCreate
     * @throws ApiError
     */
    public static telephonyWorkersList(): CancelablePromise<Array<WorkerCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/workers/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersCreate({
        requestBody,
    }: {
        requestBody: WorkerCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/workers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns WorkerCreate
     * @throws ApiError
     */
    public static telephonyWorkersRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<WorkerCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/workers/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: WorkerCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/workers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedWorkerCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/workers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyWorkersDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/workers/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns WorkerSIPLineCreate
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesList({
        workerPk,
    }: {
        workerPk: string,
    }): CancelablePromise<Array<WorkerSIPLineCreate>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/',
            path: {
                'worker_pk': workerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesCreate({
        workerPk,
        requestBody,
    }: {
        workerPk: string,
        requestBody: WorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/',
            path: {
                'worker_pk': workerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns WorkerSIPLineCreate
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesRetrieve({
        id,
        workerPk,
    }: {
        id: string,
        workerPk: string,
    }): CancelablePromise<WorkerSIPLineCreate> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'worker_pk': workerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesUpdate({
        id,
        workerPk,
        requestBody,
    }: {
        id: string,
        workerPk: string,
        requestBody: WorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'worker_pk': workerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesPartialUpdate({
        id,
        workerPk,
        requestBody,
    }: {
        id: string,
        workerPk: string,
        requestBody?: PatchedWorkerSIPLineCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'worker_pk': workerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static telephonyWorkersSipLinesDestroy({
        id,
        workerPk,
    }: {
        id: string,
        workerPk: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/telephony/workers/{worker_pk}/sip_lines/{id}/',
            path: {
                'id': id,
                'worker_pk': workerPk,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static telephonyWorkersListConcurrencyRetrieve(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/telephony/workers/list_concurrency/',
        });
    }
}
